import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle"]

  connect() {
    this.startAnimation()
  }

  disconnect() {
    if (this.animationInterval) {
      clearInterval(this.animationInterval)
    }
  }

  startAnimation() {
    // Start animation after initial fade-in completes
    setTimeout(() => this.animateToggles(), 1200)

    // Repeat animation every 8 seconds
    this.animationInterval = setInterval(() => this.animateToggles(), 8000)
  }

  animateToggles() {
    this.toggleTargets.forEach((toggle, index) => {
      // Turn on
      setTimeout(() => {
        toggle.classList.remove('toggle-btn-off')
        toggle.classList.add('toggle-btn-on')
      }, index * 1500 + 1500)

      // Turn off
      setTimeout(() => {
        toggle.classList.remove('toggle-btn-on')
        toggle.classList.add('toggle-btn-off')
      }, index * 1500 + 4500)
    })
  }

  manualToggle(event) {
    const toggle = event.currentTarget
    toggle.classList.toggle('toggle-btn-on')
    toggle.classList.toggle('toggle-btn-off')
  }
}
